import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const orderStatsChannelAggregateSlice = createApi({
    reducerPath: "orderStatsChannelAggregate",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        orderStatsChannelAggregate: builder.query({
            query: (data) => ({ url: "/order-management/api/v1/order/aggregate", params: data, method: "GET" }),
        }),
    }),
});

export const { useOrderStatsChannelAggregateQuery } = orderStatsChannelAggregateSlice;
